export const RolesEndpoint = {
    roles: `${process.env.API_BACKEND}/v1/roles/role/`,
    rolesSingle: `${process.env.API_BACKEND}/v1/roles/role/`,
} as const
